/* fanned card tilt + shine on the All Games page — same model as the homepage holo card */
(function () {
  var cards = document.querySelectorAll(".ag .agcard");
  if (!cards.length) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  Array.prototype.forEach.call(cards, function (card) {
    var raf = null;
    function move(e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.setProperty("--ry", ((x - 0.5) * 26).toFixed(2) + "deg");
        card.style.setProperty("--rx", ((0.5 - y) * 26).toFixed(2) + "deg");
        card.style.setProperty("--mx", (x * 100).toFixed(1) + "%");
        card.style.setProperty("--my", (y * 100).toFixed(1) + "%");
        card.style.setProperty("--holo-angle", (100 + (x - 0.5) * 70 + (y - 0.5) * 30).toFixed(1) + "deg");
      });
    }
    function rest() {
      card.classList.remove("is-live");
      card.style.setProperty("--rx", "0deg"); card.style.setProperty("--ry", "0deg");
      card.style.setProperty("--mx", "50%");  card.style.setProperty("--my", "50%");
      card.style.setProperty("--holo-angle", "112deg");
    }
    // pointer events cover mouse AND touch, which is what makes the homepage card feel right on a phone
    card.addEventListener("pointerenter", function () { card.classList.add("is-live"); });
    card.addEventListener("pointerdown", function () { card.classList.add("is-live"); });
    card.addEventListener("pointermove", move);
    card.addEventListener("pointerleave", rest);
    card.addEventListener("pointercancel", rest);
    card.addEventListener("pointerup", function () { setTimeout(rest, 900); });
  });
})();
